module.exports = __webpack_public_path__ + "media/images/flags/nc-93179b63758a47d5d8c3dcc4b54e451c.svg";